var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('h1', {
    staticClass: "mt-6 mb-12 text-h4 text-sm-h3 header-font"
  }, [_vm._v("Site map")]), _vm._l(_vm.links, function (link) {
    return _c('div', {
      key: link.route,
      staticClass: "mb-6"
    }, [_c('h2', {
      staticClass: "title"
    }, [_c('router-link', {
      attrs: {
        "to": link.route
      }
    }, [_vm._v(_vm._s(link.route))])], 1), _c('div', [_vm._v(_vm._s(link.details))])]);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }